module.exports = __webpack_public_path__ + "img/el.b41b5f52.svg";